import { RNG } from "rot-js";
import { LETTER_POOL } from "../../words/letters";
import { WordResult } from "../../words/wordUtils";
import { Actor } from "../Actor";
import { getRampValue } from "../Ramp";

export default {
  wordRegeneration: (
    actor: Actor,
    options: Record<number, number>,
    { wordInfo, noTriggers }: { wordInfo: WordResult; noTriggers: boolean }
  ) => {
    if (!noTriggers) {
      let max = wordInfo.word.length;
      wordInfo.crosses?.forEach((c) => {
        if (max < c.word.length) {
          max = c.word.length;
        }
      });

      const amount = Math.min(
        actor.maxLetters,
        (getRampValue(options, max) || 0) + actor.spellWand.length
      );
      for (let j = actor.spellWand.length; j <= amount; j++) {
        actor.spellWand.push(RNG.getItem(LETTER_POOL) || "");
      }
    }
  },

  wordHunger: (
    actor: Actor,
    options: Record<number, number>,
    { wordInfo }: { wordInfo: WordResult }
  ) => {
    let max = wordInfo.word.length;
    wordInfo.crosses?.forEach((c) => {
      if (max < c.word.length) {
        max = c.word.length;
      }
    });
    const amount = getRampValue(options, max);
    if (amount) {
      actor.hunger.change(amount);
    }
  },
};
